import * as React from 'react';
import { Box, Button, Menu, MenuItem } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import './styles.scss';
import {
  deleteBtnMaisClickadoSession,
  getBtnMaisClickadoSession,
  setBtnMaisClickadoSession
} from '../../../services/authentication/auth';

export default function MoreItems({
  itens,
  onSelect,
  valueTab,
  btnMaisClickado,
  setBtnMaisClickado,
  disabled
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = event => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleItemClick = (id, index) => {
    if (onSelect) {
      onSelect(null, index, id);
    }
    setBtnMaisClickadoSession();
    setBtnMaisClickado(true);
    handleClose();
  };

  React.useEffect(() => {
    if (valueTab || valueTab === 0) {
      setBtnMaisClickado(false);
      deleteBtnMaisClickadoSession();
    }
  }, [valueTab]);

  React.useEffect(() => {
    if (getBtnMaisClickadoSession()) {
      setBtnMaisClickado(true);
    }
  }, []);

  return (
    <Box className={`more-items-container ${btnMaisClickado ? 'clickado' : ''}`}>
      <Button
        aria-controls={open ? 'more-items-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        endIcon={btnMaisClickado || open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        onClick={handleClick}
        className="tab-button-more-itens"
        aria-haspopup="true"
        variant="outlined"
        disableRipple
        disabled={disabled}
      >
        Mais
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        className="more-items-menu"
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        {itens.map((item, index) => (
          <MenuItem
            key={item.id}
            className="demais-itens"
            onClick={() => handleItemClick(item.id, index)}
          >
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
}
